"use strict";

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDataProperty = getDataProperty;
exports.withDataProperty = exports.DataElementLocationsArray = exports.DataElementLocations = exports.DataElementTypesArray = exports.DataElementTypes = exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _react = _interopRequireWildcard(require("react"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _values = _interopRequireDefault(require("lodash/values"));

var _omit = _interopRequireDefault(require("lodash/omit"));

var _propTypes = _interopRequireDefault(require("prop-types"));
/**
 * Help for UI tagging for Analytics || A/B testing
 *
 * @class TaggingHelper
 */


var TaggingHelper = /*#__PURE__*/function () {
  function TaggingHelper() {
    (0, _classCallCheck2["default"])(this, TaggingHelper);
  }

  (0, _createClass2["default"])(TaggingHelper, null, [{
    key: "getDataProperty",
    value:
    /**
     * Get Data Property use like {...TaggingHelper.getDataProperty('button', 'add_domains')}
     *
     * @static
     * @param {string} propertyType - Type is used for UI testing / Analytics
     * @param {string} tag - Tag that is used for UI testing / Analytics
     * @returns {object} object - that contains 'data-property'
     *
     * @memberOf TaggingHelper
     */
    function getDataProperty(propertyType, tag) {
      if ((0, _isEmpty["default"])(tag)) {
        return {};
      }

      if (process.env.NODE_ENV !== 'production') {
        console.warn("'TaggingHelper.getDataProperty' is deprecated, start using 'getDataProperty', its exported as function not as class");
      }

      return {
        'data-property': TaggingHelper.convertToTag(tag, propertyType),
        'data-element-label': tag,
        'data-element-type': propertyType
      };
    }
    /**
     * Convert propertyType and tag to one string
     *
     * @static
     * @param {string} propertyType
     * @param {string} tag
     * @returns {string} one string
     *
     * @memberOf TaggingHelper
     */

  }, {
    key: "convertToTag",
    value: function convertToTag(propertyType, tag) {
      return "".concat(propertyType, "-").concat(tag);
    }
  }]);
  return TaggingHelper;
}();

var _default = TaggingHelper; // Element Types

exports["default"] = _default;
var DataElementTypes = {
  BUTTON: 'button',
  LINK: 'link',
  DROPDOWN: 'dropdown',
  CHECKBOX: 'checkbox',
  RADIO: 'radio',
  SLIDER: 'slider',
  FIELD: 'field',
  TAB: 'tab',
  CAROUSEL: 'carousel',
  EXPANSIONPANEL: 'expansionpanel',
  MENUITEM: 'menuitem',
  SELECT: 'select'
};
exports.DataElementTypes = DataElementTypes;
var DataElementTypesArray = (0, _values["default"])(DataElementTypes); // LocationTypes Types

exports.DataElementTypesArray = DataElementTypesArray;
var DataElementLocations = {
  HEADER: 'header',
  NAV: 'nav',
  HERO: 'hero',
  LEFT_RAIL: 'left_rail',
  BODY: 'body',
  RIGHT_RAIL: 'right_rail',
  FOOTER: 'footer',
  POP_UP: 'pop_up'
};
exports.DataElementLocations = DataElementLocations;
var DataElementLocationsArray = (0, _values["default"])(DataElementLocations);
exports.DataElementLocationsArray = DataElementLocationsArray;
var getDataPropertyShape = {
  dataElementType: _propTypes["default"].oneOf(DataElementTypesArray).isRequired,
  dataElementLocation: _propTypes["default"].oneOf(DataElementLocationsArray).isRequired,
  dataElementLabel: _propTypes["default"].string.isRequired,
  dataElementId: _propTypes["default"].string.isRequired
};

function getDataProperty(options) {
  // check is everything is set correctly
  _propTypes["default"].checkPropTypes(getDataPropertyShape, options, 'options', 'tagging-helper.getDataProperty');

  return {
    'data-element-type': options.dataElementType,
    'data-element-location': options.dataElementLocation,
    'data-element-label': options.dataElementLabel,
    'data-element-id': options.dataElementId
  };
}

var withDataProperty = function withDataProperty(WrappedComponent, ElementType) {
  var ComponentWithDataProperty = (0, _react.forwardRef)(function (props, ref) {
    return /*#__PURE__*/_react["default"].createElement(WrappedComponent, (0, _extends2["default"])({}, getDataProperty({
      dataElementType: ElementType,
      dataElementLocation: props.dataElementLocation,
      dataElementLabel: props.dataElementLabel,
      dataElementId: props.dataElementId
    }), {
      ref: ref
    }, (0, _omit["default"])(props, 'dataElementType', 'dataElementLocation', 'dataElementLabel', 'dataElementId')));
  });
  ComponentWithDataProperty.propTypes = {
    dataElementLocation: _propTypes["default"].oneOf(DataElementLocationsArray).isRequired,
    dataElementLabel: _propTypes["default"].string.isRequired,
    dataElementId: _propTypes["default"].string.isRequired
  };
  ComponentWithDataProperty.displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  return ComponentWithDataProperty;
};

exports.withDataProperty = withDataProperty;